var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { spacing } from '../../../theme';
export var StyledStepper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 360px;\n  margin: ", "px auto;\n\n  li::after {\n    top: 15%;\n  }\n"], ["\n  width: 100%;\n  max-width: 360px;\n  margin: ", "px auto;\n\n  li::after {\n    top: 15%;\n  }\n"])), spacing.base);
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map